import type { QuizQuestion } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';
import { fn, uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';

interface Signature {
  Args: {
    question: QuizQuestion;
  };
}

const toggleRequired = (question: QuizQuestion) => {
  question.required = !question.required;
};

const RequiredCheckbox: TemplateOnlyComponent<Signature> = <template>
  {{#let (uniqueId) as |id|}}
    <div class="form-check mb-3">
      <input
        type="checkbox"
        class="form-check-input"
        id={{id}}
        checked={{@question.required}}
        {{on "change" (fn toggleRequired @question)}}
      />
      <label class="form-check-label" for={{id}}>
        <strong>Mandatory</strong>
        &mdash; require an answer from the user
      </label>
    </div>
  {{/let}}
</template>;

export default RequiredCheckbox;
